import { render, staticRenderFns } from "./ClickAndBuyLinksForm.vue?vue&type=template&id=3e04b047&scoped=true"
import script from "./ClickAndBuyLinksForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyLinksForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyLinksForm.vue?vue&type=style&index=0&id=3e04b047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e04b047",
  null
  
)

export default component.exports